import endpoint from '../../app_configuration/apiEndpoints/cmsEndpoints';

const getPostalCodebyBranchId = async (branchId) => {
    const url = `${process.env.REACT_APP_PUBLIC_ECOMM_URL}${endpoint.getPostalCodeByBranch()}${branchId}`;

    const res = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    if (!res.ok) {
        return { error: true, message: 'get postal code by branch request failed', status: res.status, data: [] };
    }
    const getData = await res.json();
    return { status: res.status, data: getData };
};

export default getPostalCodebyBranchId;